import { LandingData } from "../core/buildLandingData";

export const getGlobalThemeStyles = (theme: LandingData["theme"]) => ({
  "--font-family": theme.globalStyles.fontFamily,

  "--h1-color": theme.globalStyles.h1Color,
  "--h2-color": theme.globalStyles.h2Color,
  "--h3-color": theme.globalStyles.h3Color,
  "--text-color": theme.globalStyles.textColor,

  "--button-color": theme.globalStyles.buttonColor,
  "--button-text-color": theme.globalStyles.buttonTextColor,

  "--accent-color": theme.globalStyles.accentColor,
} as React.CSSProperties);